
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/component-api/DataFilter",
      function () {
        return require("private-next-pages/component-api/DataFilter.mdx");
      }
    ]);
  